import { render, staticRenderFns } from "./bannerImg.vue?vue&type=template&id=48148862&scoped=true&"
import script from "./bannerImg.vue?vue&type=script&lang=js&"
export * from "./bannerImg.vue?vue&type=script&lang=js&"
import style0 from "./bannerImg.vue?vue&type=style&index=0&id=48148862&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48148862",
  null
  
)

export default component.exports